import React from "react";
import { Error1 } from "./errorData";
import styles from "./errorScreen.scss";

const ErrorScreen = ({ Link }) => {
  const NextLink = Link || "a";

  const errorData = Error1;
  return (
    <div className={styles["container"]}>
      {errorData.image}
      <div className={styles["description"]}>
        <h2>{errorData.heading}</h2>
        <p>{errorData.description}</p>
      </div>
      <NextLink href="/" passHref>
        <a className={styles["button"]}>返回網路商城首頁</a>
      </NextLink>
    </div>
  );
};

export default ErrorScreen;
